document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  const collapse = document.getElementById('main_nav');
  const toggler = document.querySelector('.navbar-toggler');

  collapse.addEventListener('shown.bs.collapse', () => {
    header.classList.add('menu-open');
    updateHeaderStickyState(); // call immediately to update
  });

  collapse.addEventListener('hidden.bs.collapse', () => {
    header.classList.remove('menu-open');
    updateHeaderStickyState(); // call immediately to update
  });

  // Close menu by tapping outside
  document.addEventListener('click', e => {
    if (header.classList.contains('menu-open')) {
      const insideMenu = collapse.contains(e.target);
      const isToggler = toggler.contains(e.target);
      if (!insideMenu && !isToggler) {
        new bootstrap.Collapse(collapse).hide();
      }
    }
  });
});

function updateHeaderStickyState() {
  const header = document.querySelector('header');
  const isMenuOpen = header.classList.contains('menu-open');
  if (isMenuOpen) {
    header.classList.remove('sticky-top');
  } else {
    header.classList.add('sticky-top');
  }
}

    // Observe class changes on body (for menu-open toggle)
    const observer = new MutationObserver(updateHeaderStickyState);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // Also check on scroll (if needed)
    window.addEventListener('scroll', updateHeaderStickyState);
    // Optional: check on initial load
    document.addEventListener('DOMContentLoaded', updateHeaderStickyState);
      document.getElementById('closeMobileNav').addEventListener('click', () => {
       const menu = document.getElementById('main_nav');
       const bs = bootstrap.Collapse.getInstance(menu) || new bootstrap.Collapse(menu);
       bs.hide(); // collapse the menu
       // optionally remove overlay/menu-open state
       document.body.classList.remove('menu-open');
       // restore sticky-top
       document.querySelector('header').classList.add('sticky-top');
    });
$('#product-ob').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
      dots:false,
        responsive:{
            0:{
                items:1, loop:false,    margin:0,nav:false, dots:true,
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
      ,
      1100:{
                items:1
            },
      1300:{
                items:1
            }
        }
});
$('#three-col-rating').owlCarousel({
      loop:true,
      margin:30,
      nav:true,
    dots:false,
      responsive:{
          0:{
              items:1.5, loop:true,    margin:20,nav:false,
          },
          600:{
              items:2
          },
          1000:{
              items:2
          }
    ,
    1100:{
              items:3
          },
    1300:{
              items:3
          }
      }
	});





document.addEventListener('DOMContentLoaded', function () {
  const initializedSliders = new Set();

  function initOwlCarousel($el) {
    if (!initializedSliders.has($el.attr('id'))) {
      $el.owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
          0: { items: 1.5,},
          600: { items: 3 },
          1000: { items: 4 }
        }
      });
      initializedSliders.add($el.attr('id'));
    } else {
      $el.trigger('refresh.owl.carousel');
    }
  }

  // Initialize the first visible tab slider (on load)
  const $firstVisible = $('.tab-pane.show.active .four-col-slider');
  if ($firstVisible.length) {
    setTimeout(() => initOwlCarousel($firstVisible), 200);
  }

  // Handle tab switch
  $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    const targetPaneId = $(e.target).attr('data-bs-target');
    const $slider = $(`${targetPaneId} .four-col-slider`);

    if ($slider.length) {
      // Delay slightly to allow Bootstrap layout to finish
      setTimeout(() => {
        initOwlCarousel($slider);
      }, 100);
    }
  });
});


$('#top-bar-slider').owlCarousel({
    loop:false,
    margin:0,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:1,  loop:true,dots:false,nav:true,
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
});
$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('#dynamic').addClass('newClass');
    } else {
       $('#dynamic').removeClass('newClass');
    }
});

$('#footer-icons').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:1,  loop:true,dots:true,
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});
$('#six-col').owlCarousel({
    loop:true,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:2, center: true,
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
});
$('#product-gallery').owlCarousel({
    loop:true,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:2, center: true,
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
});
$('#five-col').owlCarousel({
      loop:true,
      margin:30,
      nav:true,
    dots:false,
      responsive:{
          0:{
              items:2, center: true,
          },
          600:{
              items:3
          },
          1000:{
              items:5
          }
      }
});
$('#four-col-arrow').owlCarousel({
      loop:true,
      margin:30,
      nav:true,
    dots:false,
      responsive:{
          0:{
              items:1.5, nav:false,
          },
          600:{
              items:3
          },
          1000:{
              items:4
          }
      }
});

$('#main-slider').owlCarousel({
  loop: true,
  margin: 0,
  animateOut: 'fadeOut',
  nav: false,
  dots: true,
  autoplay: true,
  autoplayTimeout: 8000, // 8 seconds before switching slides
  autoplaySpeed: 1500,   // 1.5 second fade transition
  responsive: {
    0: {
      items: 1,
      margin: 0,
    },
    600: {
      items: 1,
      margin: 0,
    },
    1000: {
      items: 1,
      margin: 0,
    }
  }
});
$('#four-icons').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:1, dots:true,
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
});
$('#three-col-blog').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:1.5, loop:true,    margin:20,
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
});
$('#three-col').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
  dots:false,
    responsive:{
        0:{
            items:1, loop:true,    margin:20,  nav:true,
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
});

$(document).ready(function () {
    $('#four-col').owlCarousel({
      loop: false,
      margin: 20,
      nav: false,
      dots: false,
      responsive: {
        0: { items: 1.5, loop:true, },
        480: { items: 2 },
        768: { items: 3 },
        992: { items: 4 }
      }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  /////// Prevent closing from click inside dropdown
  document.querySelectorAll('.dropdown-menu').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  // Make it an accordion for smaller screens
  if (window.innerWidth < 992) {
    // Close all inner dropdowns when parent is closed
    document.querySelectorAll('.navbar .dropdown').forEach(function (everydropdown) {
      everydropdown.addEventListener('hidden.bs.dropdown', function () {
        this.querySelectorAll('.submenu').forEach(function (everysubmenu) {
          everysubmenu.style.display = 'none';
        });
      });
    });

    // Toggle submenu visibility
    document.querySelectorAll('.dropdown-menu a').forEach(function (element) {
      element.addEventListener('click', function (e) {
        let nextEl = this.nextElementSibling;
        if (nextEl && nextEl.classList.contains('submenu')) {
          e.preventDefault(); // prevent following link
          if (nextEl.style.display === 'block') {
            nextEl.style.display = 'none';
          } else {
            nextEl.style.display = 'block';
          }
        }
      });
    });
  }
})



    $(document).ready(function() {
      // Show popup when the link is clicked
      $('.showPopup').click(function() {
        $('.popupBox').show(); // Use fadeIn for smooth visibility
      });
    
      // Hide popup when the close button is clicked
      $('.closePopup').click(function() {
        $('.popupBox').hide(); // Use fadeOut for smooth disappearance
      });
    });



